import React, { useState, useEffect } from 'react';
import { Phone, Mail, ArrowUp } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import { contactInfo } from '../data/mock';
import './FloatingActions.css';

const FloatingActions = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="floating-bar" aria-label="Quick actions">
      <a
        className="fab fab-call"
        href={`tel:${contactInfo.phone}`}
        title="Call"
        aria-label="Call us"
      >
        <Phone size={22} />
      </a>
      <a
        className="fab fab-wa"
        href={contactInfo.whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        title="WhatsApp"
        aria-label="Contact on WhatsApp"
      >
        <FaWhatsapp size={24} />
      </a>
      <a
        className="fab fab-email"
        href={`mailto:${contactInfo.email}`}
        title="Email"
        aria-label="Send email"
      >
        <Mail size={22} />
      </a>
      {showScrollTop && (
        <button
          className="fab fab-top"
          onClick={scrollToTop}
          title="Back to top"
          aria-label="Scroll to top"
        >
          <ArrowUp size={22} />
        </button>
      )}
    </div>
  );
};

export default FloatingActions;
